<template>
  <div
    class="decision-engine d-flex flex-column i-px-12 i-py-11 align-items-center"
  >
    <div class="decision-engine-heading">
      <h3 class="i-text-heading-3 i-text-neutral-120 i-mb-6">
        Decision Engine
      </h3>
    </div>
    <div class="decision-engine-menu i-mb-14">
      <b-nav class="i-secondary-level-menu">
        <b-nav-item
          class="i-text-subheading-2"
          :class="{ active: $route.name.startsWith('decision-engine-checks') }"
          :active="$route.name.startsWith('decision-engine-checks')"
          :to="{ name: 'decision-engine-checks' }"
        >
          Document Checks
        </b-nav-item>
        <b-nav-item
          class="i-text-subheading-2"
          :class="{ active: $route.name.startsWith('decision-engine-rules') }"
          :active="$route.name.startsWith('decision-engine-rules')"
          :to="{ name: 'decision-engine-rules' }"
        >
          Fraud Rules
        </b-nav-item>
        <b-nav-item
          class="i-text-subheading-2"
          :class="{
            active: $route.name.startsWith('decision-engine-detectors'),
          }"
          :active="$route.name.startsWith('decision-engine-detectors')"
          :to="{ name: 'decision-engine-detectors' }"
        >
          Fraud Detectors
        </b-nav-item>
        <b-nav-item
          class="i-text-subheading-2"
          :class="{
            active: $route.name.startsWith('decision-engine-blocklist'),
          }"
          :active="$route.name.startsWith('decision-engine-blocklist')"
          :to="{ name: 'decision-engine-blocklist' }"
        >
          Blocklist
        </b-nav-item>
      </b-nav>
    </div>
    <div class="d-flex justify-content-center w-100">
      <div v-if="isOrgAdmin" class="decision-engine-page">
        <router-view @save-rules="saveRules" />
      </div>
      <empty-page v-else type="permission"></empty-page>
    </div>
    <i-toast></i-toast>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { iToast } from '@inscribe/signal';
import EmptyPage from '@/shared/components/EmptyPage.vue';

export default {
  components: { EmptyPage, iToast },
  computed: {
    ...mapGetters({
      isOrgAdmin: 'isOrgAdmin',
    }),
  },
  watch: {
    '$route.hash': function () {
      if (this.$route.hash) {
        this.scrollToSection(this.$route.hash);
      } else {
        document.querySelector('.app-wrapper').scrollTo(0, 0);
      }
    },
  },
  mounted() {
    if (this.isOrgAdmin) {
      this.getConfigRulesSchema();
    }
  },
  methods: {
    ...mapActions({
      updateConfigRules: 'updateConfigRules',
      getConfigRulesSchema: 'getConfigRulesSchema',
    }),
    scrollToSection(selector) {
      const element = document.querySelector(selector);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    },
    saveRules(rules) {
      this.updateConfigRules({ rules }).then(
        (response) => {
          this.$notify({
            group: 'api',
            type: 'success',
            title: 'Success',
            duration: 5000,
            text: 'Config saved.',
          });
        },
        (error) => {
          this.$notify({
            group: 'api',
            type: 'error',
            title: 'Something went wrong saving your config',
            duration: 5000,
            text: error.response.data.message,
          });
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.decision-engine {
  &-view,
  &-heading,
  &-page,
  &-menu {
    width: 100%;
    max-width: 1200px;

    .more-link {
      display: none;
    }

    @include respond-to('large') {
      width: 100%;
      min-width: auto !important;

      .responsive-hide {
        display: none !important;
      }

      .more-link {
        display: list-item;
      }
    }

    ::v-deep {
      .rules-list {
        width: 100%;

        .rule {
          justify-content: space-between;
        }
      }
    }
  }
}
</style>
